import { For } from '../c-mp/comp/For'
import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { html } from '../c-mp/fun/html'
import { mutateState, useState } from '../c-mp/fun/useState'
import { formatNumber } from '../fun/formatNumber'
import { getAverageAge } from '../fun/getAverageAge'
import { getDataOrThrow } from '../fun/getDataOrThrow'
import { setPageTitle } from '../fun/setPageTitle'
import { ICON_RADIO_OFF } from '../icon/ICON_RADIO_OFF'
import { ICON_RADIO_ON } from '../icon/ICON_RADIO_ON'
import { addYears } from '../model/addYears'
import { AVERAGE_AGE_BIRTH_DATE_CUTOFF } from '../model/AVERAGE_AGE_BIRTH_DATE_CUTOFF'
import { AVERAGE_AGE_GROUP_YEARS } from '../model/AVERAGE_AGE_GROUP_YEARS'
import { _ } from '../model/ccc'
import type { IPerson } from '../model/IPerson'
import { MAX_AGE } from '../model/MAX_AGE'

export const PageAverageAgeComp = defineComponent<{}>(
	'PageAverageAgeComp',
	(props, $) => {
		setPageTitle(`Átlagos életkor`)

		const data = getDataOrThrow()

		const state = useState('state', {
			isMale: false,
		})

		return (
			<div class={_.ccc_page}>
				<h1>Átlagos életkor</h1>
				<div class={_.ccc_narrow}>
					<p>Az adott idősávban született 18 év fölöttiek esetén.</p>
					<p>
						<small>
							Ha nem áll rendelkezésre adat, a legnagyobb életkor felével (
							<b>{MAX_AGE / 2 + ''} év</b>) számolunk.
							<br />
							Az{' '}
							<b>
								{AVERAGE_AGE_BIRTH_DATE_CUTOFF}–
								{addYears(
									AVERAGE_AGE_BIRTH_DATE_CUTOFF,
									AVERAGE_AGE_GROUP_YEARS - 1,
								)}
							</b>{' '}
							csoportban és az után – tekintve hogy a legmagasabb föltételezett
							életkor <b>{MAX_AGE + ''} év</b> – minden adat szükségszerűen
							alacsonyabb mint várnánk, hiszen egyesek még életben lehetnek,
							akik pedig már meghaltak, lefelé módosítják az átlagot.
						</small>
					</p>
				</div>
				<div class={_.ccc_tiles__centered__compact}>
					<button
						class={() => [
							_.ccc_button__rounded,
							!state.isMale && _.ccc__selected,
						]}
						onclick={() => {
							mutateState($.debugName, 'set female [taehxk]', () => {
								state.isMale = false
							})
						}}
					>
						<Slot
							isTrustedHtml
							get={() => (state.isMale ? ICON_RADIO_OFF : ICON_RADIO_ON)}
						/>{' '}
						Nők
					</button>
					<button
						class={() => [
							_.ccc_button__rounded,
							state.isMale && _.ccc__selected,
						]}
						onclick={() => {
							mutateState($.debugName, 'set male [taehyo]', () => {
								state.isMale = true
							})
						}}
					>
						<Slot
							isTrustedHtml
							get={() => (state.isMale ? ICON_RADIO_ON : ICON_RADIO_OFF)}
						/>{' '}
						Férfiak
					</button>
				</div>
				<div class={_.ccc_bars}>
					<For
						debugName='Átlagos életkor'
						each={() => {
							const earliestDecade =
								Math.floor(
									parseInt(
										Object.values(data.personsById)
											.reduce(
												(min, it): IPerson =>
													min == null ||
													(it.birthDate ?? '9999') < (min.birthDate ?? '9999')
														? it
														: min,
												undefined as IPerson | undefined,
											)!
											.birthDate!.slice(0, 4),
										10,
									) / AVERAGE_AGE_GROUP_YEARS,
								) * AVERAGE_AGE_GROUP_YEARS
							const lastDecade =
								Math.floor(new Date().getFullYear() / AVERAGE_AGE_GROUP_YEARS) *
									AVERAGE_AGE_GROUP_YEARS -
								AVERAGE_AGE_GROUP_YEARS
							const result = []
							for (
								let i = earliestDecade;
								i <= lastDecade;
								i += AVERAGE_AGE_GROUP_YEARS
							) {
								result.push(i)
							}
							return result
						}}
						render={({ get }) => {
							return (
								<div
									class={_.ccc_bar}
									style={() => ({
										width: `${
											(getAverageAge(data, get() + '', state.isMale).average /
												MAX_AGE) *
											100
										}%`,
									})}
								>
									<Slot
										isTrustedHtml
										get={() => {
											const averageAge = getAverageAge(
												data,
												get() + '',
												state.isMale,
											)
											return (
												html`<span
														>${get()}–${get() +
														AVERAGE_AGE_GROUP_YEARS -
														1}</span
													>
													<span>(${formatNumber(averageAge.basedOn)} fő):</span>
													<b>${averageAge.average} év</b>
													<small
														>(medián: ${formatNumber(averageAge.median)})</small
													>` + ''
											)
										}}
									/>
								</div>
							)
						}}
					/>
				</div>
			</div>
		)
	},
)
